module.exports = __webpack_public_path__ + "static/media/uvod.83b07844.webp";